export default "__VITE_ASSET__2I_plUmE__"